// extracted by mini-css-extract-plugin
export var anchor = "AutolinkHeader-module--anchor--E76Zi";
export var bxTextTruncateEnd = "AutolinkHeader-module--bx--text-truncate--end--j-vZ5";
export var bxTextTruncateFront = "AutolinkHeader-module--bx--text-truncate--front--60306";
export var header = "AutolinkHeader-module--header--dbNXG";
export var leftAnchor = "AutolinkHeader-module--left-anchor--NOwq0";
export var rightAnchor = "AutolinkHeader-module--right-anchor--DYe6a";